var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupoPersonas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.5 81.25C62.5 84.5652 63.817 87.7446 66.1612 90.0888C68.5054 92.433 71.6848 93.75 75 93.75C78.3152 93.75 81.4946 92.433 83.8388 90.0888C86.183 87.7446 87.5 84.5652 87.5 81.25C87.5 77.9348 86.183 74.7554 83.8388 72.4112C81.4946 70.067 78.3152 68.75 75 68.75C71.6848 68.75 68.5054 70.067 66.1612 72.4112C63.817 74.7554 62.5 77.9348 62.5 81.25Z",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 131.25V125C50 121.685 51.317 118.505 53.6612 116.161C56.0054 113.817 59.1848 112.5 62.5 112.5H87.5C90.8152 112.5 93.9946 113.817 96.3388 116.161C98.683 118.505 100 121.685 100 125V131.25",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.75 31.25C93.75 34.5652 95.067 37.7446 97.4112 40.0888C99.7554 42.433 102.935 43.75 106.25 43.75C109.565 43.75 112.745 42.433 115.089 40.0888C117.433 37.7446 118.75 34.5652 118.75 31.25C118.75 27.9348 117.433 24.7554 115.089 22.4112C112.745 20.067 109.565 18.75 106.25 18.75C102.935 18.75 99.7554 20.067 97.4112 22.4112C95.067 24.7554 93.75 27.9348 93.75 31.25Z",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25 62.5H118.75C122.065 62.5 125.245 63.817 127.589 66.1612C129.933 68.5054 131.25 71.6848 131.25 75V81.25",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 31.25C31.25 34.5652 32.567 37.7446 34.9112 40.0888C37.2554 42.433 40.4348 43.75 43.75 43.75C47.0652 43.75 50.2446 42.433 52.5888 40.0888C54.933 37.7446 56.25 34.5652 56.25 31.25C56.25 27.9348 54.933 24.7554 52.5888 22.4112C50.2446 20.067 47.0652 18.75 43.75 18.75C40.4348 18.75 37.2554 20.067 34.9112 22.4112C32.567 24.7554 31.25 27.9348 31.25 31.25Z",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 81.25V75C18.75 71.6848 20.067 68.5054 22.4112 66.1612C24.7554 63.817 27.9348 62.5 31.25 62.5H43.75",
    stroke: "white",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupoPersonas);
export default __webpack_public_path__ + "static/media/Grupo_Personas.1fc7ef3dfed08cadb3e637facb5082fc.svg";
export { ForwardRef as ReactComponent };